var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.MC = BOLD.BMS.MC || {};

BOLD.BMS.MC.Guide = function($) {
    "use strict";

    var settings = {
    };

    function init(data, options) {
        data = data || {};

        $.extend(true, settings, options);

        prepare(data);

        GuideList.init(data.currentPage, data.count);
    }

    function bind() {
    }

    function prepare(data) {
        var type = "";
        var content = {};
        for (var i = 0; i < data.blocks.types.length; i++) {
            type = data.blocks.types[i];
            content = data.blocks.contents[i];
    
            switch(type) {
                case "guide_item": {
                    GuideList.add(content);
                }
            }
        }
    }

    var GuideList = function() {
        var page = {
            handle: null,
            get current() {
                return list[this.handle];
            },
            set current(value) {
                this.handle = value;
            }
        };
        var displayCount = 6;
        var list = {};
        var currentIteration = 0;

        var template = {
            default: {
                $item: null,
                get get() {
                    if (!this.$item) {
                        this.update();
                    }
                    return this.$item.clone();
                },
                set set(value) {
                    this.$item = value;
                },
                update: function() {
                    var $template = $(".templates .guide-item");
                    if ($template.length > 0) this.set = $template;
                }
            }
        }

        function init(currentPage, count) {
            page.current = currentPage;
            displayCount = count || 6;
            bind();
            createItems();
        }

        function bind() {
            $(".load-more").click(function() {
                createItems();
            });
        }

        function add(content) {
            var handle = content.guide_item_related_page && content.guide_item_related_page.replace(/\/pages\//gi, "");
            
            if (!list[handle]) list[handle] = {
                handle: handle,
                list: []
            };

            list[handle].list.push({
                title: content.guide_item_title,
                enabled: content.guide_item_enabled,
                image: content.guide_item_image,
                url: content.guide_item_url,
                description: content.guide_item_description,
                tags: content.guide_item_tags ? content.guide_item_tags.split(",") : []
            });
        }

        function createItems() {
            append();
            $(".guide-description").ellipsis();
        }

        function append() {
            var $guideList = $(".guide-list");

            if ($guideList.length > 0) {
                for (var i = 1; i < displayCount + 1; i++) {
                    // List size - display count * current iteration + current index
                    var position = page.current.list.length - ((displayCount * currentIteration) + i);
                    // If current is greater than -1, append a new item 
                    if (position > -1) {
                        $guideList.append(
                            create(template.default.get, page.current.list[position])
                        );
                    }
                }
                currentIteration++;
            }

            // If there are still items left, show Load More button, hide it otherwise
            if ((page.current.list.length - (displayCount * currentIteration)) > 0) {
                $(".load-more").show();
            } else {
                $(".load-more").hide();
            }
        }

        function create($template, item) {
            
            $template.addClass(item.relatedPage + "-item");

            $template.find(".guide-link").attr({
                href: item.url
            });

            if(item.image.src) {
  $template.find(".guide-figure").css({
      backgroundImage: "url(" + item.image.src + ")"
  })
} else {
  $template.find(".guide-figure").css({
      backgroundImage: "url(" + item.image + ")"
  })
}
            
            $template.find(".guide-title").html(item.title);
            
            var $tags = $template.find(".guide-tags");
            item.tags.forEach(function(tag) {
                $tags.append(BOLD.BMS.Common.createElement("div", {
                    class: ["guide-tag", item.type + "-tag"]
                }, tag));
            });

            $template.find(".guide-description").html(item.description);

            $template.find(".read-more").attr({
                href: item.url
            });

            return $template;
        }

        return {
            init: init,
            add: add
        }
    }();

    return {
        init: init
    };

}(BOLD.jQuery || jQuery);